/**
 * Calculate the partial amount based on the total amount and the partial amount.
 *
 * @param {number} totalAmount - The total amount of the charge
 * @param {number|string} partialAmount - The partial amount (e.g., 50)
 * @returns {number} The calculated partial amount
 */
export function getPartialAmount(totalAmount, partialAmount) {
  // If totalAmount is not set or is zero, return 0
  if (!totalAmount || totalAmount <= 0) {
    return 0;
  }

  // If partialAmount is not set, return the total amount
  if (!partialAmount) {
    return totalAmount;
  }

  let calculatedAmount;

  // Treat partialAmount as a fixed amount
  calculatedAmount = parseFloat(partialAmount);
  if (isNaN(calculatedAmount) || calculatedAmount <= 0) {
    return totalAmount; // Invalid amount, return total amount
  }

  // Ensure the partial amount doesn't exceed the total amount
  return Math.min(calculatedAmount, totalAmount);
}
